import useSWR from "swr";
import { AgentService } from "@/services/agent/agent.service";
import { defaultSWROption } from "@/services/api/api.service";

export const useSubAgent = (subAgentId: string | null) => {
  const fetcher = async () => {
    if (!subAgentId) return null;
    return await AgentService.getSubAgent(subAgentId);
  };

  const { data, error, isLoading, mutate } = useSWR(
    subAgentId ? ["agent", "subAgent", subAgentId] : null,
    fetcher,
    defaultSWROption,
  );

  return {
    subAgent: data ?? null,
    error,
    isLoading,
    mutate,
  };
};
